'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Print = require('./components/Print.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Print).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/layouts-print/lib/index.js
// module id = 1422
// module chunks = 1